import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import Notice from './pages/Notice';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/notice" element={<Notice />} />
          </Routes>
        </main>
        
        <footer className="footer">
          <div className="container">
            <p>&copy; 2025 주식회사 애드플러스디벨롭먼트. All rights reserved.</p>
            <p>본 사이트는 전자공고 게시를 위한 공식 웹사이트입니다.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
